export default { 
  Template: require('./template').default,
  Public: require('./public').default,
  Errors: require('./errors').default,
}

